"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EosChasmaNationalPark = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const SelectCard_1 = require("../../inputs/SelectCard");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const ResourceType_1 = require("../../ResourceType");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Units_1 = require("../../Units");
class EosChasmaNationalPark extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.EOS_CHASMA_NATIONAL_PARK,
            tags: [Tags_1.Tags.PLANT, Tags_1.Tags.BUILDING],
            cost: 16,
            productionBox: Units_1.Units.of({ megacredits: 2 }),
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.temperature(-12)),
            metadata: {
                cardNumber: '026',
                description: 'Requires -12 C or warmer. Add 1 Animal TO ANY ANIMAL CARD. Gain 3 Plants. Increase your M€ production 2 steps.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.animals(1).asterix().plants(3).br;
                    b.production((pb) => pb.megacredits(2));
                }),
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        const cards = player.getResourceCards(ResourceType_1.ResourceType.ANIMAL);
        player.plants += 3;
        player.addProduction(Resources_1.Resources.MEGACREDITS, 2);
        if (cards.length < 1)
            return undefined;
        if (cards.length === 1) {
            player.addResourceTo(cards[0], { qty: 1, log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Add 1 animal to a card', 'Add animal', cards, (foundCards) => {
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.EosChasmaNationalPark = EosChasmaNationalPark;
//# sourceMappingURL=EOSChasmaNationalPark.js.map